import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState } from "react";
import classNames from "classnames";
import { ProductIcon } from "segments/desktop/pricing/icons/product-icon";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import PricesAndFeaturesCardsPricing from "../../prices-and-features-cards-pricing/index.js";
import FeaturesTablePricing from "../../features-table-pricing/index.js";
import { shouldSeeNewPricing } from "services/pricing-service";
import { UNIT_OF_MEASURE } from "segments/desktop/pricing/constants";
import { expandableProductRow } from "./expandable-product-row.scss";
import PlusSvg from "./svgs/plus-svg";
import MinusSvg from "./svgs/minus-svg";
const PRODUCT_TITLE_LABELS = {
    crm: "CRM",
    software: "dev",
    service: "service"
};
export const ExpandableProductRow = ({ productName, productTitle, pricesAndFeaturesCardsPricing = {} })=>{
    const [isExpanded, setIsExpanded] = useState(false);
    const productConfig = productPricingConfig[productName];
    const { primaryColor, secondaryColor } = productConfig;
    const productLabel = PRODUCT_TITLE_LABELS[productName] || productName;
    const resolvedProductTitle = productTitle || `monday ${productLabel} pricing`;
    const { isHomepagePricing = true, isApplyMaxDiffFeatures = false, defaultSeatsIndex = 0, unitOfMeasure = UNIT_OF_MEASURE.SEATS } = pricesAndFeaturesCardsPricing;
    return /*#__PURE__*/ _jsxs("div", {
        className: `jsx-${expandableProductRow.__hash}` + " " + (classNames("expandable-product-row", {
            "is-expanded": isExpanded
        }) || ""),
        children: [
            /*#__PURE__*/ _jsxs("button", {
                type: "button",
                onClick: ()=>setIsExpanded((prev)=>!prev),
                "aria-expanded": isExpanded,
                className: `jsx-${expandableProductRow.__hash}` + " " + "row-header",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: `jsx-${expandableProductRow.__hash}` + " " + "row-header-content",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: `jsx-${expandableProductRow.__hash}` + " " + "product-icon",
                                children: /*#__PURE__*/ _jsx(ProductIcon, {
                                    product: productName
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: `jsx-${expandableProductRow.__hash}` + " " + "product-title",
                                children: resolvedProductTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: `jsx-${expandableProductRow.__hash}` + " " + "toggle-icon-wrapper",
                        children: isExpanded ? /*#__PURE__*/ _jsx(MinusSvg, {}) : /*#__PURE__*/ _jsx(PlusSvg, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                "aria-hidden": !isExpanded,
                className: `jsx-${expandableProductRow.__hash}` + " " + (classNames("row-body-wrapper", {
                    "is-expanded": isExpanded
                }) || ""),
                children: /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${expandableProductRow.__hash}` + " " + "row-body-inner",
                    children: /*#__PURE__*/ _jsxs("div", {
                        style: {
                            "--primary-color": primaryColor,
                            "--secondary-color": secondaryColor
                        },
                        className: `jsx-${expandableProductRow.__hash}` + " " + "row-body",
                        children: [
                            /*#__PURE__*/ _jsx(PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingComponent, {
                                productName: productName,
                                forcePricing: "products",
                                isHomepagePricing: isHomepagePricing,
                                defaultSeatsIndex: defaultSeatsIndex,
                                unitOfMeasure: unitOfMeasure,
                                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures,
                                isNewPricing: shouldSeeNewPricing(productName),
                                crossedPricingUI: false
                            }),
                            /*#__PURE__*/ _jsx(FeaturesTablePricing.FeaturesTablePricingComponent, {
                                productName: productName,
                                forcePricing: "products",
                                isHomepagePricing: isHomepagePricing,
                                defaultSeatsIndex: defaultSeatsIndex,
                                unitOfMeasure: unitOfMeasure,
                                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures,
                                isNewPricing: shouldSeeNewPricing(productName)
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: expandableProductRow.__hash,
                children: expandableProductRow
            })
        ]
    });
};
